<template>
  <path
    d="M23.64 7.00027C23.19 6.66027 18.71 3.00027 12 3.00027C10.68 3.00027 9.44999 3.14027 8.30999 3.38027L18.43 13.5003L23.64 7.00027ZM4.11999 2.01027C3.72999 1.62027 3.09999 1.62027 2.70999 2.01027C2.31999 2.40027 2.31999 3.03027 2.70999 3.42027L4.05999 4.77027C1.90999 5.76027 0.589985 6.82027 0.359985 7.00027L10.44 19.5603C11.24 20.5603 12.76 20.5603 13.56 19.5603L15.91 16.6303L18.52 19.2403C18.91 19.6303 19.54 19.6303 19.93 19.2403C20.32 18.8503 20.32 18.2203 19.93 17.8303L4.11999 2.01027Z"
  />
</template>
